// extracted by mini-css-extract-plugin
export default {"cta":"NH-z","disabled":"OH-z"};